<li
  class="navbar-nav-item"
  routerLinkActive="navbar-nav-item__link-item--active"
>
  <a class="navbar-nav-item__link" [routerLink]="to">
    <ng-content></ng-content>
  </a>
  <span class="navbar-nav-item__link-active-marker"></span>
</li>
